import { getSsoUrl } from "@/helpers/helper";

/**
 * Full-page navigation away from the SPA. Kept on an object so tests can spy
 * on `navigation.go` (jsdom cannot navigate).
 */
export const navigation = {
  go(url: string): void {
    window.location.href = url;
  },
};

/** Sends the browser to the SSO sign-in page. */
export function redirectToSsoSignIn(): void {
  navigation.go(getSsoUrl() + "/auth/sign-in");
}
